:host {
  padding: 0 var(--_c-card-gap, 24px);
  display: block;

  menu {
    margin: 0;
    padding: 0;
  }
}

.c-card-actions {
  align-items: center;
  display: flex;
  gap: 8px;

  ::slotted(c-button[fit]) {
    flex: 1;
  }

  &--align {
    &-center {
      align-items: center;
    }

    &-start {
      align-items: flex-start;
    }

    &-end {
      align-items: flex-end;
    }
  }

  &--justify {
    &-center {
      justify-content: center;
    }

    &-end {
      justify-content: flex-end;
    }

    &-start {
      justify-content: flex-start;
    }

    &-stretch {
      justify-content: stretch;

      ::slotted(*) {
        flex: 1;
      }
    }

    &-space-between {
      justify-content: space-between;
    }

    &-space-around {
      justify-content: space-around;
    }
  }
}
